var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.959961H513V342.96H0V0.959961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.959961H171V342.96H0V0.959961ZM342 0.959961H513V342.96H342V0.959961Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 182.26C270.083 182.26 281.5 170.843 281.5 156.76C281.5 142.677 270.083 131.26 256 131.26C241.917 131.26 230.5 142.677 230.5 156.76C230.5 170.843 241.917 182.26 256 182.26Z",
    fill: "#DCC26D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2 156.86C194.2 178.96 206 199.36 225 210.36C230.9 213.76 238.5 211.76 241.9 205.86C245.3 199.96 243.3 192.36 237.4 188.96C225.9 182.36 218.9 170.06 218.9 156.86C218.9 150.06 213.4 144.46 206.5 144.46C199.6 144.46 194.2 149.96 194.2 156.86ZM289.3 208.96C307.1 197.56 317.9 177.96 317.8 156.86C317.8 150.06 312.3 144.46 305.4 144.46C298.6 144.46 293 149.96 293 156.86C293 169.56 286.5 181.36 275.9 188.16C270.1 191.76 268.2 199.36 271.8 205.16C275.4 210.96 283 212.86 288.8 209.26C289 209.16 289.1 209.06 289.3 208.96Z",
    fill: "#628A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.959961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/GT.11b220f3ad4e14712bcda16911739a71.svg";
export { ForwardRef as ReactComponent };